import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project-list",
  "use": "icon-project-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-project-list\">\r\n  <path d=\"M192 184h236l72 80h332c44.2 0 80 35.8 80 80v408c0 44.2-35.8 80-80 80H192c-44.2 0-80-35.8-80-80V264c0-44.2 35.8-80 80-80z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"76\" stroke-linejoin=\"round\" />\r\n  <path d=\"M256 452h512M256 572h512M256 692h312\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"68\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol